console.log('js/review_limit_chars.js -> v0.01');
$(function() {

	function review_limit_chars(){
	};

	if($('#review_highlight_title').length){
		$('#review_highlight_title input').on('keyup',function(){
			var numb = $('#review_highlight_title .review_limit_chars');
			var input = $('#review_highlight_title input');
			var left = input.attr('maxlength') - input.val().length;
			$(numb).text(left);
			if(left < 10){
				$(numb).addClass('review_limit_warning');
			} else {
				$(numb).removeClass('review_limit_warning');
			};
			if(left == 0){
				$(input).addClass('review_input_warning');
			} else {
				$(input).removeClass('review_input_warning');
			};
		});
	};

});
